import { useCallback, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackBar } from '../../../components/FlowBuilder/Common/SnackBar/index.tsx';
import { templateService } from '../services/templateService';
import { TEMPLATE_BASE_PATH } from '../constants/templateApi';
import { isTemplateDeletable } from '../utils/templateArchiveUtils';
import useTemplateSendDialog from './useTemplateSendDialog';

export default function useTemplateDetailsActions(template) {
  const { templateName, botNumber } = useParams();
  const navigate = useNavigate();
  const { showSnackBar } = useSnackBar();
  const { openSendDialog } = useTemplateSendDialog();
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);

  const onEdit = useCallback(() => {
    navigate(`${TEMPLATE_BASE_PATH}/edit-template/${templateName}/${botNumber}`);
  }, [botNumber, navigate, templateName]);

  const onSend = useCallback(() => {
    openSendDialog(template);
  }, [openSendDialog, template]);

  const onDeleteRequest = useCallback(() => {
    if (!isTemplateDeletable(template)) return;
    setConfirmDeleteOpen(true);
  }, [template]);

  const onConfirmDelete = useCallback(
    async (confirmed) => {
      setConfirmDeleteOpen(false);
      if (!confirmed) return;

      try {
        const res = await templateService.deleteTemplate(templateName, botNumber);
        if (res?.status === 200) {
          showSnackBar('Template deleted successfully', 'success');
          navigate(`${TEMPLATE_BASE_PATH}/template-list`);
        } else {
          showSnackBar(res?.message || 'Error deleting template. Please try again.', 'error');
        }
      } catch (error) {
        showSnackBar(error?.message || 'Error deleting template. Please try again.', 'error');
      }
    },
    [botNumber, navigate, showSnackBar, templateName]
  );

  return {
    confirmDeleteOpen,
    onEdit,
    onSend,
    onDeleteRequest,
    onConfirmDelete,
  };
}
